/**
 * Remembers the active collection and tags product links with ?from= for PDP breadcrumbs.
 */
(function () {
  const STORAGE_KEY = 'rh_nav_collection';

  /** @returns {string | null} */
  function getPageCollectionHandle() {
    const fromBody = document.body?.dataset.rhCollectionHandle;
    if (fromBody) return fromBody;

    return document.body?.dataset.rhCollectionHandle || null;
  }

  /** @param {string} handle */
  function rememberCollection(handle) {
    if (!handle) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, handle);
    } catch {
      /* no-op */
    }
  }

  /** @param {string} url @param {string} handle */
  function withFromParam(url, handle) {
    try {
      const next = new URL(url, window.location.origin);
      if (next.pathname.includes('/products/')) {
        next.searchParams.set('from', handle);
      }
      return next.toString();
    } catch {
      return url;
    }
  }

  /** @param {string} handle */
  function augmentProductLinks(handle) {
    document.querySelectorAll('a[href*="/products/"]').forEach((anchor) => {
      if (!(anchor instanceof HTMLAnchorElement)) return;
      if (anchor.dataset.rhFromAugmented === handle) return;

      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('#')) return;

      anchor.href = withFromParam(href, handle);
      anchor.dataset.rhFromAugmented = handle;
    });
  }

  /** @param {Event} event */
  function handleProductLinkClick(event) {
    const handle = getPageCollectionHandle();
    if (!handle) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const anchor = target.closest('a[href*="/products/"]');
    if (!(anchor instanceof HTMLAnchorElement)) return;

    rememberCollection(handle);

    const href = anchor.getAttribute('href');
    if (!href) return;

    const next = withFromParam(href, handle);
    if (next !== anchor.href) {
      event.preventDefault();
      window.location.assign(next);
    }
  }

  function init() {
    const handle = getPageCollectionHandle();
    if (!handle) return;

    rememberCollection(handle);
    augmentProductLinks(handle);

    document.addEventListener('click', handleProductLinkClick, true);

    const observer = new MutationObserver(() => augmentProductLinks(handle));
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
